import cssVars from 'css-vars-ponyfill'
import Navigation from './navigation'
import Global from './global'
import GMap from './gmap'
import { getCSSVars, GetURLParameter } from '../util/functional'

export default {
  init() {
    Navigation.init()
    this.setCSSVars()
    this.wooInit()
    this.cptSliderInit()
    this.quotesSlider()
    this.videoSlider()
    this.resultsSlider()
    this.videoTestimonialsSlider()
    this.videoWithPlacehoderHandler()
    this.appHeight()
    this.videoAutoInit()
    this.appointmentsCheck()
    this.keepUTMMetas()

    GMap.init()
    this.onResize()
    setTimeout(() => {
      this.resizeVideo()
    }, 100)

    $(
      'a[href^="#"]:not([href="#"],[href^="#fancy-"],[href^="#collapse-"],[href^="#pane-"],[href^="#tabs-"],[role="tab"],[data-vc-accordion])'
    ).on('click', e => {
      this.smoothScroll($(e.currentTarget).attr('href'), e)
    })
    if (window.location.hash && $(window.location.hash).length) {
      this.smoothScroll(window.location.hash)
    }

    $('a[href="#"]').on('click', e => {
      if (e) e.preventDefault()
    })

    const mainHeader = $('header.header')
    const fixHeader = () => {
      if ($(window).scrollTop() > 0 && !mainHeader.hasClass('is-sticky')) {
        mainHeader.addClass('is-sticky')
      } else if (
        $(window).scrollTop() <= 0 &&
        mainHeader.hasClass('is-sticky')
      ) {
        mainHeader.removeClass('is-sticky')
      }
    }
    fixHeader()

    $(window).on('scroll', function() {
      fixHeader()
    })

    const stepsSliders = $('.js-steps-slider')

    if (stepsSliders.length) {
      this.mobileSliderInit(
        stepsSliders,
        {
          variableWidth: true,
          infinite: true,
          swipeToSlide: true,
          focusOnSelect: true,
        },
        'sm'
      )
    }

    const teasersSliders = $('.js-teasers-slider')
    if (teasersSliders.length) {
      this.mobileSliderInit(
        teasersSliders,
        {
          variableWidth: true,
          infinite: true,
          swipeToSlide: true,
          focusOnSelect: true,
        },
        'lg'
      )
    }
  },
  onLoad() {},
  setCSSVars() {
    cssVars({
      variables: {
        '--body-width': document.body.clientWidth + 'px',
      },
    })
  },
  smoothScroll(link, e) {
    if (
      link &&
      link.indexOf('#') > 0 &&
      link.split('#')[0].indexOf(location.origin + location.pathname) !== 0
    ) {
      return false
    }
    if (e) e.preventDefault()
    let hash = false
    if (!link && window.location.hash) {
      hash = window.location.hash
    } else if (link && link.indexOf('#') >= 0) {
      hash = '#' + link.split('#')[1]
    } else if (
      link &&
      location.pathname.replace(/^\//, '') ==
        link.pathname.replace(/^\//, '') &&
      location.hostname == link.hostname
    ) {
      hash = link.hash
    }
    if (hash && $(hash).length) {
      if (Global.htmlFixedState) {
        Navigation.menuToggle()
      }
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        600
      )
      history.replaceState(null, null, hash)
    }
    $(window).trigger('hashchange')
  },
  keepUTMMetas() {
    // ?utm_campaign=cam&utm_source=source&utm_medium=medium&utm_gclid=gclid&utm_content=content&utm_keyword=keyword&utm_adgroup=adgroup&utm_adset=adset
    Global.utmMetas.forEach(function(meta) {
      const urlParam = GetURLParameter(meta)
      const storageParam = localStorage.getItem(meta)
      if (urlParam && urlParam !== storageParam) {
        localStorage.setItem(meta, urlParam)
      }
    })

    const pathName = window.location.pathname
    if (pathName.includes('/checkout/order-received/')) {
      const orderID = pathName.substring(
        pathName.indexOf('/checkout/order-received/') + 25,
        pathName.lastIndexOf('/')
      )

      if (orderID) {
        const data = {
          action: 'pch_add_utm_metas',
          order_id: orderID,
        }

        Global.utmMetas.forEach(function(meta) {
          let metaVal = ''
          const urlParam = GetURLParameter(meta)
          if (urlParam) {
            metaVal = urlParam
          } else {
            const storageParam = localStorage.getItem(meta)
            if (storageParam) {
              metaVal = storageParam
            }
          }

          if (metaVal) {
            data[meta] = metaVal
          }
        })

        /* global ajaxObj */
        $.ajax({
          url: ajaxObj.ajaxUrl,
          method: 'POST',
          dataType: 'json',
          data,
          success: function(response) {
            if (response.success) {
              Global.utmMetas.forEach(function(meta) {
                localStorage.removeItem(meta)
              })
            }
          },
        })
      }
    }
  },
  cptSliderInit() {
    const $homeSlider = $('.js-cpt-slider')
    if ($homeSlider.length) {
      const postMessageToPlayer = (player, command) => {
        if (player == null || command == null) return
        player.contentWindow.postMessage(JSON.stringify(command), '*')
      }

      $homeSlider
        .on('init', function(event, slick) {
          slick.$slides
            .not(':eq(0)')
            .find('.video--local')
            .each(function() {
              this.pause()
            })

          if (slick.$slides.eq(0).find('.video--local').length) {
            slick.$slides
              .eq(0)
              .find('.video--local')[0]
              .play()
          }
          if (slick.$slides.eq(0).find('.video--embed').length) {
            var playerId = slick.$slides
              .eq(0)
              .find('iframe')
              .attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'playVideo',
            })
          }
        })
        .on('beforeChange', function(event, slick, currentSlide) {
          // Pause youtube video on slide change
          if (slick.$slides.eq(currentSlide).find('.video--embed').length) {
            var playerId = slick.$slides
              .eq(currentSlide)
              .find('iframe')
              .attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'pauseVideo',
            })
          }
          // Pause local video on slide change
          if (slick.$slides.eq(currentSlide).find('.video--local').length) {
            slick.$slides
              .eq(currentSlide)
              .find('.video--local')[0]
              .pause()
          }
        })
        .on('afterChange', function(event, slick, currentSlide) {
          // Start playing local video on current slide
          if (slick.$slides.eq(currentSlide).find('.video--local').length) {
            slick.$slides
              .eq(currentSlide)
              .find('.video--local')[0]
              .play()
          }

          // Start playing youtube video on current slide
          if (slick.$slides.eq(currentSlide).find('.video--embed').length) {
            var playerId = slick.$slides
              .eq(currentSlide)
              .find('iframe')
              .attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'playVideo',
            })
          }
        })

      $homeSlider.slick({
        ...Global.slickDefault,
        ...$homeSlider.data('settings'),
        cssEase: 'ease',
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      })
    }
  },
  appHeight() {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()
  },
  quotesSlider() {
    const $slider = $('.js-quotes-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        // adaptiveHeight: true,
      })
    }
  },
  videoSlider() {
    const $slider = $('.js-video-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
      })
    }
  },
  resultsSlider() {
    const $slider = $('.js-results-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: true,
        dots: true,
        appendDots: '.js-results-slider-dots',
        infinite: true,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        swipeToSlide: true,
        appendArrows: '.js-results-slider-arrows',
        asNavFor: '.js-results-slider-images',
      })

      $('.js-results-slider-images').slick({
        ...Global.slickDefault,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        swipeToSlide: false,
        responsive: [
          {
            breakpoint: parseInt(getCSSVars('--bp-lg')) - 1,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: parseInt(getCSSVars('--bp-md')) - 1,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
    }
  },
  videoTestimonialsSlider() {
    const $slider = $('.js-video-testimonials-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: true,
        dots: true,
        appendDots: '.js-video-testimonials-slider-dots',
        infinite: true,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        appendArrows: '.js-video-testimonials-slider-arrows',
      })
    }
  },
  videoWithPlacehoderHandler() {
    const video = document.getElementsByClassName('js-video')
    const videoButton = document.getElementsByClassName('js-play-btn')
    const videoPlaceholder = document.getElementsByClassName('js-video-img')

    for (let i = 0; i < video.length; i++) {
      if (video[i] !== null) {
        video[i].addEventListener(
          'ended',
          () => {
            videoButton[i].classList.remove('hide')
          },
          false
        )
        video[i].onclick = () => {
          if (video[i].paused) {
            video[i].play()
            videoButton[i].classList.add('hide')
            videoPlaceholder[i].classList.add('hide')
          } else {
            video[i].pause()
            videoButton[i].classList.remove('hide')
          }
          return false
        }

        video[i].ontouchstart = () => {
          if (video[i].paused) {
            video[i].play()
            videoButton[i].classList.add('hide')
            videoPlaceholder[i].classList.add('hide')
          } else {
            video[i].pause()
            videoButton[i].classList.remove('hide')
          }
          return false
        }
      }
    }
  },
  resizeVideo() {
    const $holder = $('.js-video-wrapper')
    $holder.each(function() {
      const $videoWrapper = $(this)
      const width = 16
      const height = 9
      $videoWrapper.find('.videoHolder').each(function() {
        const $videoHolder = $(this)
        if (
          $videoWrapper.outerWidth() / width >
          $videoWrapper.outerHeight() / height
        ) {
          $videoHolder.css({
            width: '100%',
            height: 'auto',
          })
        } else {
          $videoHolder.css({
            width: ($videoWrapper.outerHeight() * width) / height,
            height: '100%',
          })
        }
      })
    })
  },
  videoAutoInit() {
    const videoBtn = $('.js-video-auto')

    if (videoBtn.length) {
      videoBtn.on('click', function() {
        const $this = $(this)
        const video = $this.next('video')

        $this.hide()

        video[0].currentTime = '0'
        video
          .prop('muted', false)
          .prop('controls', true)
          .prop('autoplay', false)
          .prop('loop', false)
      })
    }
  },
  appointmentsCheck() {
    if ($('body').hasClass('logged-in')) {
      return
    }

    function checkEmail(email) {
      $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxObj.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'check_email',
          email: email,
        },
        success: function(response) {
          if (response.success) {
            $.cookie('successfulLogin', true, { path: '/' })
            location.reload()
          } else {
            $('.email-form-message').text('Email Not Found')
          }
        },
      })
    }

    $('#email-form').on('submit', function(e) {
      e.preventDefault()
      var email = $('#email-input').val()
      checkEmail(email)
    })
  },
  wooInit() {
    const wooDropdowns = $(
      '.woocommerce-ordering .orderby, #calc_shipping_country, #dropdown_product_cat'
    )

    if (wooDropdowns.length) {
      wooDropdowns.select2({
        minimumResultsForSearch: -1,
      })
    }

    const qtyInput = $('.js-qty-input')
    if (qtyInput.length) {
      const input = qtyInput.find('[type="number"]')
      const inputMin = input.attr('min')
      const product = qtyInput.closest('div.product')
      const qtyField = product.find('.qty[type="number"]')
      const isVariable = product.hasClass('product-type-variable')
      let maxVal = input.attr('max')

      const getMaxVal = () => {
        if (isVariable) {
          const variationId = parseInt(
            product.find('[name="variation_id"]').val()
          )
          const variationArray = product
            .find('.variations_form')
            .data('product_variations')
            .find(el => el.variation_id == variationId)
          console.log('variationArray', variationArray) //eslint-disable-line
          if (variationArray !== undefined && variationArray.max_qty) {
            return variationArray.max_qty
          } else {
            return 9999
          }
          console.log('variationArray', variationArray) //eslint-disable-line
        } else {
          const maxval = product.find('[name="quantity"]').attr('max')

          if (!maxval) {
            return 9999
          }

          return maxval
        }
      }

      input.on('change keyup', function() {
        const $this = $(this)
        const val = $this.val()

        if (!maxVal || isVariable) {
          maxVal = getMaxVal()
          input.attr('max', maxVal)
        }

        if (!val) {
          input.val(1)
          qtyField.val(1)
        } else if (val > maxVal) {
          input.val(maxVal)
          qtyField.val(maxVal)
        } else if (val < inputMin) {
          input.val(1)
          qtyField.val(1)
        } else {
          qtyField.val(val)
        }
      })

      qtyInput.on('click', '.plus', function() {
        if (!maxVal || isVariable) {
          maxVal = getMaxVal()
          input.attr('max', maxVal)
        }

        const currentVal = parseInt(input.val())
        if (currentVal < maxVal) {
          input.val(currentVal + 1).trigger('change')
        }
      })

      qtyInput.on('click', '.minus', function() {
        const currentVal = parseInt(input.val())
        if (currentVal > inputMin) {
          input.val(currentVal - 1).trigger('change')
        }
      })

      if (isVariable) {
        const variationSelect = $('.variations_form select').val()
        const $label = $('.variations .variation-label')
        if (!$label.length) {
          $('.variations .label').append(
            '<span class="variation-label">' + variationSelect + '<span>'
          )
        }

        product.on('change', '.variations_form select', function() {
          input.val(1).trigger('change')

          const $select = $(this)
          const selectVal = $select.val()
          product.find('.variation-label').text(selectVal)
        })
      }
    }

    const calendarForm = $('.wc-appointments-appointment-form-wrap.cart')
    if (calendarForm.length) {
      $('.wc-appointments-appointment-form-wrap.cart').on(
        'calendar-data-loaded',
        function() {
          $('.picker').datepicker('option', 'numberOfMonths', 2)
          $('.picker').datepicker('option', 'selectOtherMonths', false)
        }
      )
    }
  },
  onResize() {
    $(window).resize(() => {
      this.setCSSVars()
      setTimeout(() => {
        this.resizeVideo()
      }, 100)
    })
  },
  mobileSliderInit($slider, args = {}, bp = 'sm') {
    const viewport = window.bootstrapToolkit
    $slider.each(function() {
      const slider = $(this)
      const sliderArgs = {
        ...Global.slickDefault,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        ...args,
      }
      const sliderCheck = () => {
        if (viewport.is(`<${bp}`)) {
          if (!slider.hasClass('slick-initialized')) {
            slider.slick(sliderArgs)
          }
        } else {
          if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick')
          }
        }
      }
      sliderCheck()
      $(window).resize(
        viewport.changed(function() {
          sliderCheck()
        })
      )
    })
  },
}
